module.exports = __webpack_public_path__ + "static/media/Agility.e6736a95.svg";